import { render, staticRenderFns } from "./AdvisorCoreNav.vue?vue&type=template&id=1f370822&scoped=true&"
import script from "./AdvisorCoreNav.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f370822",
  null
  
)

export default component.exports